import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContractPaymentStatus } from 'src/utils/constants/contracts';

const ReportBureauPaymentStatus = ({ paymentStatus }) => {
  const { t } = useTranslation();
  const isUpToDate = paymentStatus === ContractPaymentStatus.UP_TO_DATE;

  return (
    <Chip
      label={
        isUpToDate
          ? t('BUREAU_REPORTS.UP_TO_DATE')
          : t('BUREAU_REPORTS.OVERDUE')
      }
      color={isUpToDate ? 'success' : 'error'}
      size="small"
    />
  );
};

ReportBureauPaymentStatus.propTypes = {
  paymentStatus: PropTypes.string.isRequired
};

export default ReportBureauPaymentStatus;

